/**
 * ChatInput Component
 *
 * Status: [IMPLEMENTED]
 * Task: T2.1 - Chat UI Component
 *
 * Text input field with send button.
 */

import React, { useState, useRef, useEffect } from 'react';

const ChatInput = ({ onSend, disabled }) => {
  const [inputValue, setInputValue] = useState('');
  const textareaRef = useRef(null);

  // Auto-resize textarea based on content
  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = Math.min(120, Math.max(40, textarea.scrollHeight)) + 'px';
    }
  }, [inputValue]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputValue.trim() && !disabled) {
      onSend(inputValue);
      setInputValue('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="border-t border-gray-200 dark:border-slate-700 p-4 bg-gray-50 dark:bg-slate-900 transition-colors"
    >
      <div className="flex space-x-2 items-end">
        <textarea
          ref={textareaRef}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          placeholder="Type your message..."
          maxLength={500}
          rows={1}
          className="flex-1 px-4 py-2 border border-gray-300 dark:border-slate-600 rounded-2xl
                     bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100
                     placeholder:text-gray-400 dark:placeholder:text-slate-500
                     focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent
                     disabled:bg-gray-100 dark:disabled:bg-slate-700 disabled:cursor-not-allowed
                     resize-none overflow-y-auto min-h-[40px] max-h-[120px]
                     scrollbar-hide transition-colors"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          aria-label="Message input"
        />
        <button
          type="submit"
          disabled={disabled || !inputValue.trim()}
          className="px-6 py-2 bg-sky-600 text-white rounded-full font-medium
                     hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-500
                     disabled:bg-gray-300 dark:disabled:bg-slate-600 disabled:cursor-not-allowed
                     transition-colors"
          aria-label="Send message"
        >
          {disabled ? (
            <span className="inline-block w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
          ) : (
            'Send'
          )}
        </button>
      </div>
      <p className="text-xs text-gray-400 dark:text-slate-500 mt-2 text-right">
        {inputValue.length}/500
      </p>
    </form>
  );
};

export default ChatInput;
